import React, { Ref, useImperativeHandle, useState } from "react";
import EditRequestNameDialog, { EditRequestNameDialogProps } from "../../Dashboard/EditRequestNameDialog";

const DIALOG_HIDDEN_PROPS = {
  onSave: (value: string): void => {},
  onClose: (): void => {},
  open: false,
};

export type EditRequestNameDialogHolderRef = {
  show: (dialogProps: EditRequestNameDialogProps) => void;
  hide: () => void;
  isOpen: () => boolean;
  cancel: () => void;
};

function EditRequestNameDialogHolder(props: {}, ref: Ref<EditRequestNameDialogHolderRef> | undefined) {
  const [dialogProps, setDialogProps] = useState(DIALOG_HIDDEN_PROPS);

  useImperativeHandle(ref, () => ({
    show: (newDialogProps: EditRequestNameDialogProps): void => {
      setDialogProps(newDialogProps);
    },
    hide: () => {
      setDialogProps(DIALOG_HIDDEN_PROPS);
    },
    isOpen: () => dialogProps.open,
    cancel: () => dialogProps.onClose(),
  }));

  return <EditRequestNameDialog {...dialogProps} />;
}

export default React.forwardRef(EditRequestNameDialogHolder);
